/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Billing_SubscribeInputs */

const en_settings_billing_subscribe = /** @type {(inputs: Settings_Billing_SubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscribe`)
};

const zh_settings_billing_subscribe = /** @type {(inputs: Settings_Billing_SubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`立即订阅`)
};

/**
* | output |
* | --- |
* | "Subscribe" |
*
* @param {Settings_Billing_SubscribeInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_billing_subscribe = /** @type {((inputs?: Settings_Billing_SubscribeInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Billing_SubscribeInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_billing_subscribe(inputs)
	return zh_settings_billing_subscribe(inputs)
});
export { settings_billing_subscribe as "settings.billing.subscribe" }